module.exports = __webpack_public_path__ + "img/Premium Clover 1.42a844c7.jpg";